import { ReactElement } from "react";

import styles from "./index.module.css";
import { useNavigate } from "../../lib/navigate";
import { useKeyboardShortcuts } from "../../lib/keyboard";
import Header from "../shared/Header";

const shortcuts = [
  {
    title: "paint",
    shortcuts: [
      {
        name: "brush tool",
        command: "1",
      },
      {
        name: "flood tool",
        command: "2",
      },
      {
        name: "line tool",
        command: "3",
      },
      {
        name: "undo",
        command: "cmd + z",
      },
      {
        name: "redo",
        command: "cmd + shift + z",
      },
      {
        name: "clear",
        command: "del",
      },
      {
        name: "fill",
        command: "f",
      },
      {
        name: "invert",
        command: "i",
      },
    ],
  },

  {
    title: "transform",
    shortcuts: [
      {
        name: "shift by one pixel",
        command: "▲ ▼ ◀ ▶",
      },
      {
        name: "reflect over x-axis",
        command: "cmd + ▲ ▼",
      },
      {
        name: "reflect over y-axis",
        command: "cmd + ◀ ▶",
      },
      {
        name: "rotate -90°",
        command: "[",
      },
      {
        name: "rotate +90°",
        command: "]",
      },
    ],
  },

  {
    title: "manage",
    shortcuts: [
      {
        name: "new",
        command: "cmd + enter",
      },
      {
        name: "make a copy",
        command: "cmd + c",
      },
      {
        name: "delete",
        command: "cmd + del",
      },
      {
        name: "download as .png",
        command: "cmd + s",
      },
    ],
  },

  {
    title: "navigate",
    shortcuts: [
      {
        name: "show/hide shortcuts",
        command: "0",
      },
      {
        name: "show/hide settings",
        command: "/",
      },
      {
        name: "go back",
        command: "esc",
      },
    ],
  },
];

export default function Shortcuts(): ReactElement {
  const navigate = useNavigate();
  useKeyboardShortcuts({
    close: () => navigate(-1),
    shortcuts: () => navigate(-1),
  });

  return (
    <div className={styles.wrapper}>
      <Header title={"shortcuts"} modal={true} />

      <main className={styles.layout}>
        {shortcuts.map((shortcutGroup, i) => (
          <div className={styles.card} key={i}>
            <h1 className={styles.title}>{shortcutGroup.title}</h1>
            {shortcutGroup.shortcuts.map((shortcut, i) => (
              <div key={i} style={{ display: "contents" }}>
                <span className={styles.command}>{shortcut.command}</span>
                <span>{shortcut.name}</span>
              </div>
            ))}
          </div>
        ))}
      </main>
    </div>
  );
}
